<template>
    <div></div>
</template>

<script>
export default {
    name: "PrometBase"
}
</script>

<style scoped>

</style>